export const SOURCE_PURPOSE_LABELS = {
  automation_generation: 'Automation Generation',
  automation_knowledge_extraction: 'Automation Knowledge Extraction',
  dev_code_knowledge_extraction: 'Dev Code Knowledge Extraction',
};

const FORBIDDEN_RENDER_FIELDS = new Set([
  'token',
  'secret',
  'encrypted_token',
  'decrypted_token',
  'private_key',
  'github_pat',
  'raw_source',
  'source_text',
  'file_content',
  'provider_payload',
  '__dict__',
  'token_encrypted',
  'credential_id',
]);

export function purposeLabel(sourcePurpose) {
  return SOURCE_PURPOSE_LABELS[sourcePurpose] || sourcePurpose || 'Unknown purpose';
}

export function formatBool(value) {
  return value ? 'Yes' : 'No';
}

export function formatDate(value) {
  if (!value) {
    return '-';
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString();
}

export function safeConfigs(response) {
  return Array.isArray(response?.configs) ? response.configs : [];
}

export function safeBindings(response) {
  return Array.isArray(response?.bindings) ? response.bindings : [];
}

export function countPrimaryGenerationBindings(configs) {
  return configs.reduce((count, config) => {
    const bindings = Array.isArray(config.purpose_bindings) ? config.purpose_bindings : [];
    return count + bindings.filter(
      (binding) => binding.source_purpose === 'automation_generation' && binding.is_primary,
    ).length;
  }, 0);
}

export function repositoryErrorMessage(err) {
  if (err?.status === 401) {
    return 'Authentication required.';
  }
  if (err?.status === 403) {
    return 'Admin access required.';
  }
  if (err?.status === 404) {
    return 'Repository source configuration was not found.';
  }
  if (err?.status === 409) {
    return 'Repository source configuration conflict.';
  }
  return err?.status ? `Request failed (${err.status}).` : 'Request failed.';
}

export function containsForbiddenField(value, path = '') {
  if (value == null || typeof value !== 'object') {
    return null;
  }

  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      const hit = containsForbiddenField(value[index], `${path}[${index}]`);
      if (hit) {
        return hit;
      }
    }
    return null;
  }

  return Object.entries(value).reduce((found, [key, nested]) => {
    if (found) {
      return found;
    }
    const nextPath = path ? `${path}.${key}` : key;
    if (FORBIDDEN_RENDER_FIELDS.has(key)) {
      return nextPath;
    }
    return containsForbiddenField(nested, nextPath);
  }, null);
}
